import {Component, Input, OnInit, AfterViewChecked} from '@angular/core';
import {LotteriesService} from '../../lotteries.service';
import * as globals from '../../settings';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IncomingdrawsService} from '../../_services/incomingdraws.service';
import {SubscriptionsService} from '../../_services/subscriptions.service';

@Component({
    selector: 'app-how-it-works',
    templateUrl: './how-it-works.component.html',
    styleUrls: ['./how-it-works.component.scss']
})
export class HowItWorksComponent implements OnInit {
    lottery: any;
    lotteries: any;
    lottNumbers: any[];
    lotteryWord: any;
    showVerify: any;
    modalSize: any;
    showRestricted: any;
    paymentSucceeded: boolean;
    devMode: boolean;
    prevent: boolean;
    quickPick: number;
    quickPickPrice: number;
    quickPickCurrency: string;
    public isRegistred: any;
    lotteryId: number;
    lotteryName: string;
    urlLotteryName: string;
    quickPickPackageId: number;
    user: any;
    quickPickName: string;
    noOffer: boolean;
    isLoadingButton: boolean;
    showLang: any;
    incomingDrawsSubscription: Subscription;
    brand = globals.brand;

    constructor(public lotteryService: LotteriesService, private router: Router,
                public incomingDraws: IncomingdrawsService, private subscriptionsService: SubscriptionsService) {
    }

    ngOnInit() {
        this.getLang();
        const user = localStorage.getItem('playerDetails');
        this.user = JSON.parse(user);
        this.isLoadingButton = false;
    }

    getLang() {
        if (localStorage.getItem('pageLanguage') === 'de'
         || localStorage.getItem('pageLanguage') === 'vi'
         || localStorage.getItem('pageLanguage') === 'id'
         || localStorage.getItem('pageLanguage') === 'en') {
            this.showLang = localStorage.getItem('pageLanguage');
        } else {
            setTimeout(() => {
                this.getLang();
            }, 200);
        }
    }

}
